import _ from 'lodash'
import Constants from '@/constants'
import Util from '@/util'
import moment from 'moment'
import FormConstants from '@/base/formconstants'

export const JobStatus = {
  DRAFT: 0,
  OPEN: 1,
  ON_HOLD: 2,
  FILLED: 3,
  CANCELED: 4,
}

const FormOpeningConstants = Object.freeze({
  Form: {
    COLUMNS: [{
      name: 'first',
      label: 'First Name (Legal)',
      type: 'input',
      class: 'is-4',
    }, {
      name: 'last',
      label: 'Last Name (Legal)',
      type: 'input',
      class: 'is-4',
    }, {
      name: 'stub',
      type: 'stub',
      class: 'is-12',
    }, {
      name: 'email',
      label: 'Email',
      type: 'input',
      class: 'is-4',
    }, {
      name: 'phone',
      label: 'Phone',
      type: 'input',
      class: 'is-4',
    }, {
      name: 'stub',
      type: 'stub',
      class: 'is-12',
    }, {
      name: 'address',
      label: 'Address',
      type: 'input',
      class: 'is-12',
    }, {
      name: 'stub',
      type: 'stub',
      class: 'is-12',
    }, {
      name: 'countryId',
      label: 'Country',
      type: 'select',
      data: 'dataCountries',
      class: 'is-4',
    }, {
      name: 'stateId',
      label: 'State/Province',
      type: 'select',
      data: 'dataStates',
      class: 'is-4',
    }, {
      name: 'city',
      label: 'City',
      type: 'input',
      class: 'is-4',
    }, {
      name: 'zip',
      label: 'Zip Code/Postal Code',
      type: 'input',
      class: 'is-4',
    // }, {
    //   name: 'stub',
    //   type: 'stub',
    //   class: 'is-12',
    // }, {
    //   name: 'countryId',
    //   label: 'Country',
    //   type: 'select',
    //   data: 'dataCountries',
    //   class: 'is-4',
    }],

    KEYS: [
      { key: 'openingId', type: 'int', default: undefined, isValidate: false },
      { key: 'id', type: 'int', default: undefined, isValidate: false },
      { key: 'status', type: 'int', default: Constants.ApplicantStatus.NEW, isValidate: false },
      // info
      { key: 'first', type: 'string', default: undefined },
      { key: 'last', type: 'string', default: undefined },
      { key: 'email', type: 'string', default: undefined, isEmail: true },
      { key: 'phone', type: 'string', default: undefined },
      // address
      { key: 'address', type: 'string', default: undefined },
      { key: 'city', type: 'string', default: undefined },
      { key: 'countryId', type: 'int', default: undefined },
      { key: 'stateId', type: 'int', default: undefined },
      { key: 'zip', type: 'string', default: undefined },
      // // objects (intermediate)
      // { key: 'references', type: 'array', default: [] },
      // { key: 'licenses', type: 'array', default: [] },
      // // refs
      // { key: 'opening', type: 'object', omit: true },
      // { key: 'uploads', type: 'array', omit: true },
      // // others
      // { key: 'createdAt', type: 'string', omit: true },
      // { key: 'createdBy', type: 'int', omit: true },
      // { key: 'modifiedAt', type: 'string', omit: true },
      // { key: 'modifiedBy', type: 'int', omit: true },
    ],

    KEYS_FILL: [
      // { key: 'openingId', type: 'int', default: undefined },
      // { key: 'id', type: 'int', default: undefined },
      { key: 'status', type: 'int', default: Constants.ApplicantStatus.NEW },
      // info
      { key: 'first', type: 'string', default: 'Shark' },
      { key: 'last', type: 'string', default: 'Applicant' },
      { key: 'email', type: 'string', default: 'test@gmail.com' },
      { key: 'phone', type: 'string', default: '(123)123-1234' },
      // address
      { key: 'address', type: 'string', default: 'test addr 1' },
      { key: 'city', type: 'string', default: 'city1' },
      { key: 'stateId', type: 'int', default: 1 },
      { key: 'zip', type: 'string', default: '112233' },
      { key: 'countryId', type: 'int', default: 1 },
    ],

    getValidators: (instance, params = {}) => {
      // let isRelocate = params.isRelocate
      // let isProvidedService = params.isProvidedService
      let validators = {
        // field: [{ required: true, trigger: 'blur', message: 'Required' }],
        // created_at: [{ required: true, trigger: 'blur', message: 'Required' }],
        first: [{ required: true, trigger: 'blur', message: 'Required' }],
        last: [{ required: true, trigger: 'blur', message: 'Required' }],
        phone: [
          { required: true, trigger: 'blur', message: 'Required' },
          // { required: true, trigger: 'blur', validator: Util.validators.validatorRegex.bind(instance), regex: new RegExp('^(\\([0-9]{3}\\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$'), message: 'Invalid format, e.g.: (123)123-1234' },
        ],
        email: [
          { required: true, trigger: 'blur', message: 'Required' },
          { required: true, trigger: 'blur', validator: Util.validators.validateEmail.bind(instance) }
        ],
        // mname: [{ required: true, trigger: 'blur', message: 'Required' }],
        // lname: [{ required: true, trigger: 'blur', message: 'Required' }],
        address: [{ required: true, trigger: 'blur', message: 'Required' }],
        // address2: [{ required: true, trigger: 'blur', message: 'Required' }],
        city: [{ required: true, trigger: 'blur', message: 'Required' }],
        stateId: [{ required: true, trigger: 'change', message: 'Required' }],
        zip: [{ required: true, trigger: 'blur', message: 'Required' }],
        countryId: [{ required: true, trigger: 'change', message: 'Required' }],
        // isRelocate: [{ required: true, trigger: 'change', message: 'Required' }],
        // relocateTo: [{ required: isRelocate, trigger: 'blur', message: 'Required' }],
        // isProvidedService: [{ required: true, trigger: 'change', message: 'Required' }],
        // providedServiceDateFrom: [{ required: isProvidedService, trigger: 'blur', message: 'Required' }],
        // providedServiceDateTo: [{ required: isProvidedService, trigger: 'blur', message: 'Required' }],
        // images: [{ required: true, trigger: 'change', validator: Util.validators.validateFileRequired.bind(instance) }],
      }
      return validators
    },

    ENABLERS: [
      {
        key: 'relocateTo',
        criteria: [
          { param: 'isRelocate', value: Constants.OptionsYesNo.YES }
        ]
      }, {
        key: 'providedServiceDateFrom',
        criteria: [
          { param: 'isProvidedService', value: Constants.OptionsYesNo.YES }
        ]
      }, {
        key: 'providedServiceDateTo',
        criteria: [
          { param: 'isProvidedService', value: Constants.OptionsYesNo.YES }
        ]
      },
    ],

    updateEnablers: (instance, columns, form = {}) => {
      let enablers = FormOpeningConstants.Form.ENABLERS
      for (let e in enablers) {
        let enabler = enablers[e]
        let key = enabler.key
        let criterias = enabler.criteria || []
        let disabled = (!criterias || criterias.length <= 0)
        for (let c in criterias) {
          let criteria = criterias[c]
          let param = criteria.param
          let value = criteria.value
          if (!form.hasOwnProperty(param)) {
            disabled = true
            continue
          }
          if (form[param] !== value) {
            disabled = true
            continue
          }
        }
        let found = _.find(columns, (col) => col.name === key)
        if (found) {
          instance.$set(found, 'disabled', disabled)
        }
      }
    },
  },

  FormRef: {
    KEYS: [
      { key: 'name', type: 'string', default: undefined },
      { key: 'relationship', type: 'string', default: undefined },
      { key: 'phone', type: 'phone', default: undefined },
      { key: 'email', type: 'email', default: undefined, isEmail: true },
    ],

    KEYS_FILL: [
      { key: 'name', type: 'string', default: 'TestRef' },
      { key: 'relationship', type: 'string', default: 'Friend' },
      { key: 'phone', type: 'phone', default: '(123)123-1234' },
      { key: 'email', type: 'email', default: 'some@test.com' },
    ],

    // getKeys: (refNo = 1, keys = FormOpeningConstants.FormRef.KEYS) => {
    //   let keyinfos = Util.array.copy(keys)
    //   for (let k in keyinfos) {
    //     let keyinfo = keyinfos[k]
    //     let key = keyinfo.key
    //     if (key) keyinfo.key = key.replace(/{%refNo%}/g, `${refNo}`)
    //   }
    //   return keyinfos
    // },

    getValidators: (instance) => {
      let keyinfos = Util.array.copy(FormOpeningConstants.FormRef.KEYS)
      let validators = {}
      for (let k in keyinfos) {
        let keyinfo = keyinfos[k]
        let key = keyinfo.key
        let type = keyinfo.type
        // if (key) key = key.replace(/{%refNo%}/g, `${refNo}`)
        switch (type) {
          case 'string':
            validators[key] = [{ required: true, trigger: 'blur', message: 'Required' }]
            break
          case 'email':
            validators[key] = [
              { required: true, trigger: 'blur', message: 'Required' },
              { required: true, trigger: 'blur', validator: Util.validators.validateEmail.bind(instance) }
            ]
            break
          case 'phone':
            validators[key] = [
              { required: true, trigger: 'blur', message: 'Required' },
              // { required: true, trigger: 'blur', validator: Util.validators.validatorRegex.bind(instance), regex: new RegExp('^(\\([0-9]{3}\\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$'), message: 'Invalid format, e.g.: (123)123-1234' },
            ]
            break
          default:
            throw new Error(`not supported type: ${type} in getValidators()`)
        }
      }
      return validators
    },

    COLUMNS: [{
      name: 'name',
      type: 'input',
      label: 'Name',
      class: 'is-3'
    }, {
      name: 'relationship',
      type: 'input',
      label: 'Relationship',
      class: 'is-3'
    }, {
      name: 'phone',
      type: 'input',
      label: 'Phone',
      class: 'is-3'
    }, {
      name: 'email',
      type: 'input',
      label: 'Email',
      class: 'is-3'
    }],

    // getColumns: (refNo = 1) => {
    //   let columns = Util.array.copy(FormOpeningConstants.FormRef.COLUMNS)
    //   for (let k in columns) {
    //     let col = columns[k]
    //     let name = col.name
    //     if (name) col.name = name.replace(/{%refNo%}/g, `${refNo}`)
    //   }
    //   return columns
    // },
  },

  FormUpload: {
    COLUMNS: [{
      name: 'files',
      label: '‌‌ ',
      buttonLabel: 'Choose File',
      buttonStyle: {
        borderRadius: '24px',
      },
      buttonClass: 'column is-full',
      tip: 'Max file size: 60 MB.',
      // labelCustom: {
      //   type: 'link',
      //   isExternal: true,
      //   label: 'Guideline',
      //   url: 'https://sta360piris.blob.core.windows.net/iris-acc360-docs/A360OnboardingProcessImages.pdf'
      // },
      type: 'upload',
      listType: 'text',
      accept: 'image/png,image/jpeg,image/jpg,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf',
      // accept: 'application/pdf,application/msword,image/png,image/jpeg,image/jpg',
      limit: 1,
      // isUploadHidden: true,
      // isCustomUpload: true, // custom upload
      // isCustomUploadLabel: 'Upload/Gallery',
      uploadPrefix: 'listing/variant/',
      isAutoUpload: false,
      class: 'is-4',
      // prefixInfo: {
      //   label: 'Upload the product’s main (front) image for each SKU. If the product contains more than one SKU due to different flavors, colors, sizes, etc… the default image should reflect that.'
      // }
    }, {
      name: 'doNotOwn',
      // label: '‌‌ ',
      label: 'I currently do not hold this license, but my anticipated date of obtaining this certification/license is:',
      type: 'checkbox',
      class: 'is-4',
    }, {
      name: 'expectedObtainDate',
      label: 'Date',
      type: 'date_picker',
      class: 'is-4',
      disabled: true,
    }],

    KEYS: [
      { key: 'files', type: 'file', default: [] },
      { key: 'doNotOwn', type: 'boolean', numberToBoolean: true, default: false },
      { key: 'expectedObtainDate', type: 'string', default: undefined },
    ],

    getValidators: (instance, params = {}) => {
      const doNotOwn = params.doNotOwn
      let validators = {
        files: [{ required: (doNotOwn == null || doNotOwn === false), trigger: 'change', validator: Util.validators.validateFileRequired.bind(instance) }],
        doNotOwn: [{ required: false, trigger: 'change' }],
        expectedObtainDate: [{ required: (doNotOwn === true), trigger: 'change', message: 'Required' }],
      }
      return validators
    },
  },

  FormResume: {
    KEYS: [
      { key: 'files', type: 'file', default: [] },
      { key: 'dateAvailable', type: 'string', default: undefined },
      { key: 'desiredPay', type: 'string', default: undefined },
      // { key: 'assignedId', type: 'int', default: undefined },
    ],

    KEYS_FILL: [
      { key: 'files', type: 'file', default: [] },
      { key: 'dateAvailable', type: 'string', default: moment().format(FormConstants.Moment.EL_DATE_FORMAT) },
      { key: 'desiredPay', type: 'string', default: '$1001' },
      // { key: 'assignedId', type: 'int', default: undefined },
    ],

    COLUMNS: [{
      name: 'files',
      // label: '‌‌ ',
      label: 'Resume',
      buttonLabel: 'Choose File',
      buttonStyle: {
        borderRadius: '24px',
      },
      buttonClass: 'column is-full',
      tip: 'Max file size: 60 MB.',
      // labelCustom: {
      //   type: 'link',
      //   isExternal: true,
      //   label: 'Guideline',
      //   url: 'https://sta360piris.blob.core.windows.net/iris-acc360-docs/A360OnboardingProcessImages.pdf'
      // },
      type: 'upload',
      listType: 'text',
      accept: 'image/png,image/jpeg,image/jpg,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf',
      // accept: 'application/pdf,application/msword,image/png,image/jpeg,image/jpg',
      limit: 1,
      // isUploadHidden: true,
      // isCustomUpload: true, // custom upload
      // isCustomUploadLabel: 'Upload/Gallery',
      uploadPrefix: 'listing/variant/',
      isAutoUpload: false,
      class: 'is-4',
      // prefixInfo: {
      //   label: 'Upload the product’s main (front) image for each SKU. If the product contains more than one SKU due to different flavors, colors, sizes, etc… the default image should reflect that.'
      // }
    }, {
      name: 'stub',
      type: 'stub',
      class: 'is-12',
    }, {
      name: 'dateAvailable',
      label: 'Date Available',
      type: 'date_picker',
      class: 'is-6',
      pickerOptions: Util.date.getOptionsFromToday(),
      format: FormConstants.EL_DATE_FORMAT_DISPLAY,
      valueFormat: FormConstants.EL_DATE_FORMAT,
    }, {
      name: 'desiredPay',
      label: 'Desired Pay',
      type: 'input',
      class: 'is-6',
    }],

    getValidators: (instance, params = {}) => {
      let validators = {
        files: [{ required: true, trigger: 'change', validator: Util.validators.validateFileRequired.bind(instance) }],
        // extra info
        dateAvailable: [{ required: true, trigger: 'blur', message: 'Required' }],
        desiredPay: [
          { required: true, trigger: 'blur', message: 'Required' },
          // { required: true, trigger: 'blur', validator: Util.validators.validatorInteger.bind(instance) },
        ],
      }
      return validators
    },
  },

  FormUploadQuestion: {
    KEYS: [
      { key: 'id', type: 'int', default: undefined },
      { key: 'openingUploadQuestionId', type: 'int', default: undefined },
      { key: 'question', type: 'string', default: undefined },
      { key: 'required', type: 'boolean', default: undefined },
      { key: 'files', alias: 'uploads', type: 'file', default: [] },
    ],

    KEYS_FILL: [
      { key: 'id', type: 'int', default: undefined },
      { key: 'openingUploadQuestionId', type: 'int', default: undefined },
      { key: 'question', type: 'string', default: undefined },
      { key: 'required', type: 'boolean', default: undefined },
      { key: 'files', alias: 'uploads', type: 'file', default: [] },
    ],

    COLUMNS: [{
      name: 'files',
      // label: '‌‌ ',
      label: '(File Upload)',
      buttonLabel: 'Choose File',
      buttonStyle: {
        borderRadius: '24px',
        // maxWidth: '33%',
        clear: 'both',
        display: 'block',
      },
      buttonClass: 'column is-full is-4-desktop',
      tip: 'Max file size: 60 MB.',
      // labelCustom: {
      //   type: 'link',
      //   isExternal: true,
      //   label: 'Guideline',
      //   url: 'https://sta360piris.blob.core.windows.net/iris-acc360-docs/A360OnboardingProcessImages.pdf'
      // },
      type: 'upload',
      listType: 'text',
      accept: 'image/png,image/jpeg,image/jpg,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf',
      // accept: 'application/pdf,application/msword,image/png,image/jpeg,image/jpg',
      limit: 1,
      // isUploadHidden: true,
      // isCustomUpload: true, // custom upload
      // isCustomUploadLabel: 'Upload/Gallery',
      uploadPrefix: 'listing/variant/',
      isAutoUpload: false,
      class: 'is-12',
      // prefixInfo: {
      //   label: 'Upload the product’s main (front) image for each SKU. If the product contains more than one SKU due to different flavors, colors, sizes, etc… the default image should reflect that.'
      // }
    }],

    getValidators: (instance, params = {}) => {
      const isFileRequired = params.isFileRequired
      let validators = {
        files: [{ required: isFileRequired, trigger: 'change', validator: Util.validators.validateFileRequired.bind(instance) }],
      }
      return validators
    },
  },
})

export default FormOpeningConstants
